import { Form } from './approval-forward-model-controller';

type IdType = number | string | undefined;

interface ForwardBody {
  roleId: IdType,
  physicalPersonId: number | string,
  approvalSeq: IdType,
  approvalProcessSeq: IdType,
  observation: string
}

interface FormBody extends ForwardBody, Record<string, any> {}

const normalizeForwardBody = (formData: Form, approvalSeq: IdType, approvalProcessSeq: IdType): FormBody => ({
  roleId: formData.role && formData.role.id,
  physicalPersonId: formData.physicalPerson.physicalPersonId,
  observation: formData.observation,
  approvalProcessSeq,
  approvalSeq,
});

export {
  normalizeForwardBody,
  FormBody,
};
